import api from "../../../services/apiClient"
import type { AgencyVisitDetail, AgencyVisitFormValues } from "../models/agencyVisit"

const BASE = "agency-visit"

export const agencyVisitApi = {
  getList: async (params?: Record<string, unknown>) => {
    const { data } = await api.get(BASE, { params })
    return data?.data ?? data
  },

  getById: async (id: number): Promise<AgencyVisitDetail> => {
    const { data } = await api.get(`${BASE}/${id}`)
    return data?.data ?? data
  },

  create: async (values: AgencyVisitFormValues) => {
    const { data } = await api.post(`${BASE}/create`, values)
    return data?.data ?? data
  },

  update: async (id: number, values: AgencyVisitFormValues) => {
    const { data } = await api.put(`${BASE}/update/${id}`, values)
    return data?.data ?? data
  },

  delete: async (id: number) => {
    const { data } = await api.delete(`${BASE}/delete/${id}`)
    return data
  },

  updateStar: async (id: number, rating: number) => {
    const { data } = await api.post(`${BASE}/update-star/${id}`, { rating })
    return data?.data ?? data
  },

  getUsers: async () => {
    const { data } = await api.get(`${BASE}/users`)
    return data?.data ?? data
  },

  getAgencies: async () => {
    const { data } = await api.get(`${BASE}/agencies`)
    return data?.data ?? data
  },
}
